webpackJsonp([239460580129473],{

/***/ 1636:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AccountCreditItem","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":"The client's account credit balance, in cents","isDeprecated":false,"name":"balanceCents","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"familyName","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"givenName","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":"The client's id","isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"args":[],"deprecationReason":null,"description":"Name of the client's primary location","isDeprecated":false,"name":"locationName","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-account-credit-item-fe64444de539f59c5c23.js